<template>
    <div>
        <md-dialog class="terms-dialog" :md-active.sync="showDialog" :md-click-outside-to-close="false">

            <div class="terms-dialog-wrapper">
                <md-dialog-actions>
                    <md-button class="md-tertiary md-raised" @click="closeAnalytics">Cancel</md-button>
                    <md-button class="md-accent md-raised" @click="acceptAnalytics">Save and close</md-button>
                </md-dialog-actions>

                <h2 class="md-dialog-title md-headline">Our use of cookies</h2>

                <md-dialog-content>
                    <p>We use necessary cookies to make our site work. We'd also like to set optional analytics cookies to help us improve it. We won't set optional cookies unless you enable them. Using this tool will set a cookie on your device to remember your preferences.</p>
                    <hr>
                    <h3 class="md-title">Necessary cookies</h3>
                    <p>Necessary cookies and unique identifiers enable core functionality such as security, network management, and accessibility. You may disable these by changing your browser settings, but this may affect how the website functions.</p>
                    <hr>
                    <h3 class="md-title">Analytics cookies</h3>
                    <p>We'd like to collect analytics to help us to improve our website by collecting and reporting information on how you use it.</p>
                    <md-switch v-model="acceptedAnalytics">On</md-switch>
                </md-dialog-content>
            </div>


        </md-dialog>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { functions } from "../firebaseFunctions.js";
import { AuthService } from "@/services/auth.service";

export default {
    name: 'AnalyticsDialog',
    props: {},
    data: () => ({
        user: null,
        showDialog: false,
        acceptedAnalytics: true,
        noAnalyticsSet: null
    }),
    created() {
        let self = this;
        this.subscription = AuthService.loggedUser$.subscribe((user) => {
            self.user = user;
        })

        // Show the dialog if analyticsAgreed is unset or set to null
        this.showDialog = (typeof this.user.analyticsAgreed === 'undefined' || this.user.analyticsAgreed === null);

    },
    beforeDestroy() {
        this.subscription.unsubscribe();
    },
    methods: {
        closeAnalytics() {
            this.showDialog = false;
            this.$emit("cancel-analytics", this.showDialog);
        },
        acceptAnalytics() {
            this.showDialog = false;

            let userAnalyticsClaims = {
                analyticsAgreed: this.acceptedAnalytics
            }

            this.user = Object.assign(this.user, userAnalyticsClaims);

            functions.updateAnalytics(this.user).then( function() {
                AuthService.refreshCurrentUser(this.user);
            }.bind(this));
        }
    } //ends methods
}
</script>

<style lang="scss" scoped>

    .terms-dialog {
        .terms-dialog-wrapper {
            max-width: 768px;
            overflow: auto;
            background: #323232;
            color: #ffffff;
        }

        .md-dialog-content {
            width: 100%;
        }
    }
</style>
